import React from "react";

const CreatePostponeClass = React.lazy(() => import("./CreatePostponeClass"));

export const postponeClassRoute = [
	{
		path: "/admin/postponeClass/create",
		name: "Postpone Class",
		element: <CreatePostponeClass />,
	},
];
